module.exports = __webpack_public_path__ + "static/media/GUDGEON.0821059f.jpg";